;(function( $ ) {
	'use strict';
	var $window     = $( window ),
		isImageLink = function( i, node ) {
			var $node  = $( node ),
				search = $node.get( 0 ).search, // The search string
				hash   = $node.get( 0 ).hash,
				href   = $node.prop( 'href' ).replace( search, '' ).replace( hash, '' ); // The link without the search string or hash.

			// Only links that point to images or videos
			return href.match( /\.(jpg|jpe|jpeg|png|gif|bmp|m4v|mp4)$/ );
		};

	$window.on( 'nivosetup', function() {
		var $popups = $( 'a.overlay-popup' ),
			$images = $( 'a > img:only-child' ).parent() // Find all anchors that wrap around an image.
											   .filter( isImageLink ) // We only want those links that point at images.
											   .attr( 'data-lightbox-gallery', 'gallery' ); // Add them all to the same gallery

		// We have a something to do so do something
		if ( $images.length >= 1 ) {
			$images.nivoLightbox( { clickOverlayToClose: true, keyboardNav: true } );
		}

		if ( $popups.length >= 1 ) {
			$popups.nivoLightbox( { clickOverlayToClose: false, keyboardNav: true } );
		}
	} );

	$( document ).ready( function() {
		$window.trigger( 'nivosetup' );
	} );
}( jQuery ));
